const _excluded = ["refreshOnHookMount", "keepDataFresh"],
  _excluded2 = ["data", "isFetching", "isInitialLoading", "refetch", "error", "isLoading"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import { useCallback, useMemo, useState } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useStore, useStoreActions } from "../../contexts.ts";
export const useQueryState = options => {
  const {
    queryKey
  } = options;
  const {
      refreshOnHookMount: _refreshOnMount,
      keepDataFresh = false
    } = options,
    restOptions = _objectWithoutProperties(options, _excluded);
  const queryKeyString = useMemo(() => JSON.stringify(queryKey), [queryKey]);
  const [previousQueryKeyString, setPreviousQueryKeyString] = useState(queryKeyString);
  const queryClient = useQueryClient();
  function getRefetchOnMount(query, refreshOnMount) {
    if (typeof refreshOnMount === 'function') {
      return refreshOnMount(query) ? 'always' : keepDataFresh;
    }
    return refreshOnMount ? 'always' : keepDataFresh;
  }
  const _useQuery = useQuery(_objectSpread(_objectSpread(_objectSpread({
      keepPreviousData: previousQueryKeyString === queryKeyString,
      retry: false,
      refetchOnMount: query => getRefetchOnMount(query, options.refreshOnHookMount)
    }, keepDataFresh ? {
      staleTime: 0
    } : {}), restOptions), {}, {
      onSettled: () => {
        setPreviousQueryKeyString(queryKeyString);
      },
      networkMode: 'always'
    })),
    {
      data,
      isFetching,
      isInitialLoading,
      refetch,
      error,
      isLoading: _isLoading
    } = _useQuery,
    rest = _objectWithoutProperties(_useQuery, _excluded2);
  const {
    setQueryAsLoading
  } = useStoreActions();
  const isQueryLoading = useStore(state => !!state.isQueryLoading[queryKeyString]);
  const isLoading = useMemo(() => isInitialLoading || isQueryLoading, [isInitialLoading, isQueryLoading]);
  const refetchData = useCallback(async function () {
    let {
      silent = true,
      throwOnError = true
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    !silent && setQueryAsLoading(queryKeyString, true);
    try {
      return await refetch({
        throwOnError,
        cancelRefetch: false
      });
    } finally {
      !silent && setQueryAsLoading(queryKeyString, false);
    }
  }, [queryKeyString]);
  const optimisticUpdate = updaterOrValue => {
    queryClient.setQueryData(queryKey, old => {
      if (!old) {
        throw new Error('Optimistic update called with undefined data');
      }
      if (typeof updaterOrValue === 'function') {
        return updaterOrValue(old);
      }
      return updaterOrValue;
    });
  };

  // todo: inprogress: attach to fetch or refetch if needed
  // const attachToFetchOrRefetch = async () => {
  //     if (isFetching) {
  //         return queryClient.fetchQuery({ ...restOptions });
  //     } else {
  //         const data = await refetchData();
  //         return data?.data;
  //     }
  // };

  return _objectSpread({
    data,
    optimisticUpdate,
    isFetching,
    isLoading,
    isBackgroundLoading: isFetching && !isLoading,
    refresh: refetchData,
    error
  }, rest);
};